import React, {Component} from 'react'
import {getUserRightDataList,
    deleteUserRightData,getUserRightOptionsList,
    getRightUserList,saveUserRightData
} from '../../request'
import {Button, Modal, Popconfirm, Table, Radio, Form, Select, Drawer, message} from "antd";
import './index.less'
let columnsKey = {
    Name: "业务模块",
    fieldName: "字段名",
    fieldAliasName: "字段别名",
    fieldType: "字段类型",
    fieldValue: "字段值",
    hidden: "是否隐藏",
    edit: "是否可编辑",
}
class DataRight extends Component {
    formRef = React.createRef();
    state = {
        dataRightList: [],
        columns:[],
        userList:[],
        dataTable:[],
        formParam:{
            menuId:this.props.resourceId,
            rightFields:[],
            dataId:[],
            usersId:[]
        },
        loading:false,
        userRightVisible:false,
        userDataId:null,
        currentRecord:{}
    }
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'center'
            }
            if(item == 'Name'){
                return  {
                    ...initObj,
                    width: 160,
                }
            }else if(item == 'fieldName'||item=='fieldAliasName'||item=='fieldType'){
                return  {
                    ...initObj,
                    width: 80,
                }
            }else if(item == 'fieldValue'){
                return  {
                    ...initObj,
                    render: (text, record, index) => {
                        return (
                            <>
                                {
                                    record.hasOwnProperty(item)?
                                    <Form.Item name={[ 'rightFields',record.parentIndex,'children',index,'selectedValue'] }>
                                        <Select
                                            mode="tags"
                                            // tokenSeparators={[',']}
                                            options={record.fieldValueArr}
                                        />
                                    </Form.Item>
                                        :''
                                }


                            </>
                        )
                    }
                }
            }else if(item == 'hidden'||item == 'edit'){
                return  {
                    ...initObj,
                    width: 140,
                    render: (text, record, index) => {
                        if(!record.hasOwnProperty(item)) return null
                        return (
                            <>
                                <Form.Item
                                    name={[ 'rightFields',record.parentIndex,'children',index,item] }>
                                    <Radio.Group>
                                        <Radio value={1}>是</Radio>
                                        <Radio value={0}>否</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }

    getRightDataList = (userDataId)=> {
        getUserRightOptionsList({ userDataId:userDataId}).then(res=> {

            let setResult = res.map((item,index)=>{
                item.children = (item.children||[]).map(child=>{
                    child.fieldValueArr = child.fieldValue?child.fieldValue.split(',').map(field=>{
                        return {
                            label: field,
                            value: field
                        }
                    }):[]
                    child.parentIndex =  index
                    child.selectedValue =  child.selectedValue?child.selectedValue.split(','):[]
                    return child
                })
                return item
            })
            this.setState(prevState => ({
                formParam: {
                    ...prevState.formParam,
                    rightFields: [...prevState.formParam.rightFields, ...setResult]
                }
            }),()=>{
                console.log('formRef',this.formRef)
                if(this.formRef){
                    this.formRef.current.setFieldsValue(this.state.formParam)

                }
            })
            console.log('formparam',this.state.formParam)
        })
    }
    getRightUserDataList = ()=> {
        getRightUserList({ menuId:this.props.resourceId}).then(res=> {
            this.setState({
                userList: res
            })
        })
    }
    formValueChange = (value,allValues)=>{
        console.log(value,allValues,value.value)

        if(value.hasOwnProperty('rightFields')){
            let parentIndex = Object.keys( value.rightFields)[0]
            let dataIndex = Object.keys( Object.values( value.rightFields)[0].children)[0]
            let dataValue = Object.values( Object.values( value.rightFields)[0].children)[0]
            console.log('parentIndex,dataIndex,dataValue',parentIndex,dataIndex,dataValue)
            let {rightFields} = this.state.formParam
            let param = [...rightFields]
            param[parentIndex].children[dataIndex] = {...param[parentIndex].children[dataIndex],...dataValue}

            if(dataValue.hasOwnProperty('hidden')&&dataValue.hidden==1){
                param[parentIndex].children[dataIndex] = {...param[parentIndex].children[dataIndex],edit:0,...dataValue}
            }else if(dataValue.hasOwnProperty('edit')&&dataValue.edit==1){
                param[parentIndex].children[dataIndex] = {...param[parentIndex].children[dataIndex],hidden:0,...dataValue}
            }
            this.setState(prevState => ({
                formParam: {
                    ...prevState.formParam,
                    rightFields: [...param]
                }
            }))
            // rightFields
        }else if(value.hasOwnProperty('dataId')){
            this.setState(prevState => ({
                formParam: {
                    ...prevState.formParam,
                    ...value,
                },
            }),()=>{
                this.formRef.current.setFieldValue({rightFields:[...this.state.formParam.rightFields]})
            })
        }else{
            this.setState(prevState => ({
                formParam: {
                    ...prevState.formParam,
                    ...value,
                }
            }))
        }
        console.log('formparam',this.state.formParam)
    }
    saveUserRightData = () => {
        let params = {...this.state.formParam}
        params.rightFields = params.rightFields.filter(item=>params.dataId.indexOf(item.id)>-1).map(item=>{
            item.children = item.children.map(child=>{
                child.selectedValue = child.selectedValue.join(',')
                return child
            })
            return item
        })
        params.userIds = params.userIds.join(',')
        params.dataId = params.dataId.join(',')
        saveUserRightData( {...params}).then(res=>{
            message.success('保存成功')
            this.props.onRefreshList()
            this.closeDrawer()
        })
    }
    openUserRightDetail = (currentRecord)=>{
        console.log(currentRecord)
        this.getRightDataList(currentRecord.id)
        this.getRightUserDataList()
        let params = this.state.formParam
        if(currentRecord.id){
            params.dataId = [currentRecord.dataId]
            params.userIds = [currentRecord.userId]
        }
        this.setState({
            userRightVisible:true,
            currentRecord,
            formParam:{...params}
        })
    }
    closeDrawer = () => {
        let initParam = {
            menuId:this.props.resourceId,
            rightFields:[],
            dataId:[],
            usersId:[]
        }
        this.formRef.current.setFieldsValue(initParam)
        this.setState({
            userRightVisible:false,
            formParam:{
                ...initParam
            },
            currentRecord:{}
        })
    }
    componentDidMount() {
        this.createColumns(columnsKey);

    }
    render() {
        console.log(this.props)
        let {columns,loading,formParam} = this.state
        return (
            <>
                <Drawer
                    title={
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            批量编辑/新增用户权限
                            <Button danger type="primary" onClick={() => this.saveUserRightData()}>保存</Button>
                        </div>
                    }
                    onClose={() => this.closeDrawer()}
                    width={'70%'}
                    open={this.state.userRightVisible}
                >
                    <Form
                        ref={this.formRef}
                        labelAlign="right"
                        labelWrap={true}
                        preserve={false}
                        initialValues={formParam}
                        onValuesChange={this.formValueChange}
                        validateMessages={this.validateMessages}
                    >
                        <Form.Item
                            label={'选择用户'}
                            name={'userIds'}>
                            <Select
                                style={{minWidth: '200px'}}
                                showSearch
                                optionFilterProp="children"
                                mode={'multiple'}
                                fieldNames={{
                                    label: 'userNick',
                                    value: 'userId'
                                }}
                                filterOption={(input, option) => {
                                    let searchText = option?.userNick ?? ''
                                    return searchText.toLowerCase().includes(input.toLowerCase())
                                }}
                                allowClear
                                placeholder="请选择"
                                options={this.state.userList}
                            />
                        </Form.Item>
                        <Form.Item
                            label={'选择业务模块'}
                            name={'dataId'}>
                            <Select
                                style={{minWidth: '200px'}}
                                showSearch
                                optionFilterProp="children"
                                mode={'multiple'}
                                fieldNames={{
                                    label: 'Name',
                                    value: 'id'
                                }}
                                filterOption={(input, option) => {
                                    let searchText = option?.Name ?? ''
                                    return searchText.toLowerCase().includes(input.toLowerCase())
                                }}
                                allowClear
                                placeholder="请选择"
                                options={this.state.formParam.rightFields}
                            />
                        </Form.Item>
                        <Table
                            className={'user-right-table'}
                            bordered
                            size="small"
                            pagination={false}
                            dataSource={formParam.rightFields.filter(item=>formParam.dataId.indexOf(item.id)>-1)}
                            rowKey={record => record.hasOwnProperty('children')?record.id:record.dataId+'_'+record.id}
                            columns={columns}
                            loading={loading}
                            expandable={{
                                defaultExpandAllRows: true,
                            }}
                            scroll={{ x: 1000 }}
                        />
                    </Form>
                </Drawer>

            </>
        )
    }
}
export default DataRight